<template>
<div>
    <input :value="url" style="font-size: 15px; letter-spacing: 0px; color: #606B86; min-width: 100%;">
    </input>
</div>
</template>
<script>
export default {
    name: 'Url',
    props: {
        url: {
            type: String,
            default: 'https://example.com'
        },
    }
}
</script>
<style>
</style>